import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { DIALOG_DATA } from '../../../../global.variable';

@Component({
  selector: 'gtapp-upload-type',
  templateUrl: './upload-type.component.html',
  styleUrl: './upload-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UploadTypeComponent {
  offlineMode = !navigator.onLine;
  fileType: string = 'image';
  showFrom: string = '';
  constructor(
    protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public dialogueData: any,
  ) {}

  ngOnInit(): void {
    this.showFrom = this.dialogueData.showFrom;
  }
  onDismis(close: any, timeStamp = false) {
    this.dialogRef.close({
      timeStamp: timeStamp,
      value: close,
      fileType: this.fileType,
    });
  }
}
